import styled from 'styled-components'

export const CatalogItemRowStyled = styled.div<{
  $wrap?: boolean
  $grow?: boolean
}>`
  display: flex;
  align-items: center;
  flex-wrap: ${(props) => (props.$wrap ? 'wrap' : 'nowrap')};
  gap: ${(props) => props.theme.space.small};

  ${(props) =>
    props.$grow &&
    `
    flex: 1;
    min-width: 0;
  `}
`
